import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import ListControl from './listControl/';

class Classify extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { rank, content, id } = this.props;

        let list = <p>暂无数据</p>;

        const rankName = ['A——F', 'G——L', 'M——T', 'U——Z'];
        const rankid = ['AF', 'GL', 'MT', 'UZ'];
        const rankData = ['A', 'G', 'M', 'U'];

        if (rank) {
            list = content.map((current, index) => {
                // console.log('dd==', current);
                // console.log('dddd==', rankName[index], 'eeee===', current[rankName[index]]);
                console.log('cu==', current);

                return (
                    <div key={index} id={`${id}${rankid[index]}`} className={styles.classify}>
                        <div className={styles.name}>{rankName[index]}</div>
                        <ListControl content={current[rankData[index]]} />
                    </div>
                );
            });
        } else {
            list = <ListControl content={content} />;
        }

        return <div className={styles.cont}>{list}</div>;
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
Classify.propTypes = { rank: PropTypes.bool, content: PropTypes.array, id: PropTypes.string };

/**
 * 定义组件默认属性
 * */
Classify.defaultProps = {};

export default Classify;
